<template>
    <div :class="$style['form-item']" :style="{lineHeight:lineHeight+'px'}">
        <span :class="$style['item-label']" :style="{width:labelWidth}">
            <span :class="$style.red" v-if="required">*</span>
            {{label}}
        </span>
        <div :class="$style['form-item-content']">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
  name: 'pt-form-item',
  props: {
    label: {
      type: String,
      default: ''
    },
    labelWidth: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    lineHeight: {
      type: String,
      default: '55'
    }
  }
}
</script>

<style module lang="less">
.form-item{
    display: flex;
    // align-items: center;
    margin-bottom: 10px;
    &:last-child{
        margin-bottom: 0;
    }
    >span{
        text-align: right;
        margin-right: 10px;
        color: #333333;
        vertical-align: middle;
        font-size: 15px;
    }
    .form-item-content{
        flex: 1;
        align-self: center;
        overflow: hidden
    }
    .red{
        color:red;
    }
}
.item-label{
    white-space: nowrap
}
</style>
